angular.module("App.evals.grid", [])
    .directive("evalGrid", function($timeout, $rootScope) {
        return {
            restric: 'A',
            templateUrl: "evalGrid.html",
            //template:'{{users}}',
            // scope: {
            //  "users": "=gridUsers",  //user Array
            //  "questions": "=gridQuestions",  // hashes with userIds hashing the questions.
            //  "userCommentsDictionary": "=gridUserCommentsDictionary",
            //  "evaluationTitle": "=evaluationTitle",
            //  "modelForChildScope": "="
            // },
            link: function postLink(scope, element, attribute) {
                function renderGrid() {
                    $timeout(function() {
                        var contentHeightArray = [];
                        var contentTr = element.find(".jv-tableContents").find("tr");
                        var titlesHeightArray = [];
                        var titlesTr = element.find(".jv-tableTitles").find("tr");
                        var finalHeightArray = [];


                        var findMaxHeight = function(elementTr) {
                            var tdArr = element.find(elementTr).find("td");
                            var max = 0;
                            angular.forEach(tdArr, function(value, key) {
                                var height = angular.element(value).outerHeight();
                                if (max < height) {
                                    max = height;
                                }
                            });
                            return max;
                        };


                        angular.forEach(contentTr, function(element, index) {
                            // var contentHeight = angular.element(element).height();
                            // var titleHeight = angular.element(titlesTr[index]).height();

                            var contentHeight = findMaxHeight(element);
                            var titleHeight = findMaxHeight(titlesTr[index]);

                            contentHeightArray.push(contentHeight);
                            titlesHeightArray.push(titleHeight);

                            //TODO: need to clean up the extra code here.
                            if (titlesHeightArray[index] > contentHeightArray[index]) {
                                finalHeightArray.push(titlesHeightArray[index]);
                            } else {
                                finalHeightArray.push(contentHeightArray[index]);
                            }
                        });

                        angular.forEach(finalHeightArray, function(height, index) {
                            angular.element(titlesTr[index]).find("td").height(height + "px");
                            angular.element(contentTr[index]).find("td").height(height + "px");
                        });
                        adjustScrollers();
                    }, 1);

                }

                function adjustScrollers() {

                    var $evalWrapper = $("#jv-evalWrapper");
                    scope.showRightScroller = false;
                    scope.showLeftScroller = false;
                    var containerWidth = $evalWrapper.width();
                    var gridWidth = $(".jv-evaluationGrid").width();
                    var scrollableArea = (gridWidth - containerWidth) >= 0 ? (gridWidth - containerWidth) : 0;

                    var mouseoverId = null;
                    $("#jv-evalWrapper, .jv-scroller").off("mouseover");
                    $("#jv-evalWrapper, .jv-scroller").on("mouseover", function() {
                        clearTimeout(mouseoverId);
                        mouseoverId = setTimeout(function() {
                            var scrollLeft = $evalWrapper.scrollLeft();
                            if (scrollLeft != scrollableArea) {
                                scope.showRightScroller = true;
                            }
                            if (scrollLeft !== 0) {
                                scope.showLeftScroller = true;
                            }
                            scope.$apply();
                        }, 500);

                    });

                    var mouseoutId = null;
                    $evalWrapper.off("mouseout");
                    $evalWrapper.on("mouseout", function() {
                        clearTimeout(mouseoutId);
                        mouseoutId = setTimeout(function() {
                            scope.showRightScroller = false;
                            scope.showLeftScroller = false;
                            scope.$apply();
                        }, 500);
                    });


                    var timeoutId = null;
                    var tempNumber = 15;
                    var scrollDistance = 10;
                    var animationTime = tempNumber;
                    var animationInterval = tempNumber;
                    $(".jobseeker-arrow-left").off("mouseover");
                    $(".jobseeker-arrow-left").on("mouseover", function() {
                        timeoutId = setInterval(function() {
                            $evalWrapper.animate({
                                scrollLeft: '-=' + scrollDistance
                            }, animationTime, 'easeOutQuad');
                        }, animationInterval);
                    });

                    $(".jobseeker-arrow-right").off("mouseover");
                    $(".jobseeker-arrow-right").on("mouseover", function() {
                        timeoutId = setInterval(function() {
                            $evalWrapper.animate({
                                scrollLeft: '+=' + scrollDistance
                            }, animationTime, 'easeOutQuad');
                        }, animationInterval);

                    });

                    var scrollTimer = null;
                    $evalWrapper.off('scroll');
                    $evalWrapper.on('scroll', function() {
                        setTimeout(function() {
                            var scrollLeft = $evalWrapper.scrollLeft();
                            if (scrollLeft === 0) {
                                scope.showLeftScroller = false;
                            } else {
                                scope.showLeftScroller = true;
                            }

                            if (scrollLeft == scrollableArea) {
                                scope.showRightScroller = false;
                            } else {
                                scope.showRightScroller = true;
                            }
                            scope.$apply();
                        }, 10);
                    });
                    $(".jv-scroller").off("mouseout");
                    $(".jv-scroller").on("mouseout", function() {
                        clearInterval(timeoutId);
                        $evalWrapper.stop(true);
                    });

                    var scrollerPosition = $(".jv-scroller").css("top");
                    var scrollerTimeout = null;
                    $(window).off('scroll');
                    $(window).on('scroll', function() {
                        clearTimeout(scrollerTimeout);
                        scrollerTimeout = setTimeout(function() {
                            var scrollDistance = $(window).scrollTop();
                            $(".jv-scroller").css("top", parseInt(scrollerPosition, 10) + scrollDistance);
                        }, 100);
                    });
                }

                scope.$watch("users", function(newValue, oldValue) {
                    if (angular.isUndefined(newValue) || newValue === null) {
                        return;
                    }
                    renderGrid();
                });

            }
        };
    });
